export const navbarLink = [
  {
    label: "About",
    path: "http://tekkabuzz.com/af/NV0RcqxB/inplay",
  },
  {
    label: "Responsible Gaming",
    path: "http://tekkabuzz.com/af/NV0RcqxB/inplay",
  },
  {
    label: "Most Played",
    path: "http://tekkabuzz.com/af/NV0RcqxB/inplay",
  },
  {
    label: "Promotions",
    path: "http://tekkabuzz.com/af/NV0RcqxB/inplay",
  },
  {
    label: "FAQs",
    path: "http://tekkabuzz.com/af/NV0RcqxB/inplay",
  },
];
